import { takeLatest, put, call, fork, race, take } from 'redux-saga/effects';
import { getEquipmentInfoRequest } from 'equipment/info/containers/info-actions';
import { getOrderDetailsRequest } from 'order/details/containers/details-actions';
import callApi from 'utils/api';
import merge from 'lodash.merge';
import * as actionTypes from './constants';

import {
  installedAtInfoSuccess,
  installedAtInfoFailure,
  saveInstalledAtInfoFailure,
  saveInstalledAtInfoSuccess,
  verifyInstalledAtInfoSuccess,
  verifyInstalledAtInfoFailure,
} from './installed-at-info-actions';

export function* doFetchInstalledAtInfo(action) {
  try {
    const { results, requestCancelled } = yield race({
      results: call(callApi, {
        endpoint: `info/installedat/${action.payload.installedAtId}`,
        options: {
          errorMessage: `Could not get info for installed at ${action.payload.installedAtId}`,
          retryAction: action,
        },
      }),
      // Check if user redirects to equipment info or order details.
      // In that case, stop the installedAt info request to prevent
      // wrong data on the equipment info or order details page
      requestCancelled: take([getOrderDetailsRequest, getEquipmentInfoRequest]),
    });

    if (!requestCancelled) {
      yield put(installedAtInfoSuccess(results));
    }
  } catch (err) {
    yield put(installedAtInfoFailure(err));
  }
}

export function* doSaveInstalledAtInfo(action) {
  try {
    const { data, values } = action.payload;
    const request = merge({}, data, values);
    const { results, navigatedAway } = yield race({
      results: call(callApi, {
        endpoint: `info/update/installedat/${data.id}`,
        options: {
          method: 'PUT',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(request),
          errorMessage: `Could not update info for installed at ${data.id}`,
          retryAction: action,
        },
      }),
      navigatedAway: take('LOCATION_CHANGE'),
    });
    if (!navigatedAway) {
      yield put(saveInstalledAtInfoSuccess(results));
    }
  } catch (err) {
    yield put(saveInstalledAtInfoFailure(err));
  }
}

export function* verifyInstalledAtInfo(action) {
  try {
    const { id } = action.payload;
    const results = yield call(callApi, {
      endpoint: `info/verify/installedat/${id}`,
      options: {
        method: 'PUT',
        errorMessage: `Could not verify installed at ${id}`,
        retryAction: action,
      },
    });
    yield put(verifyInstalledAtInfoSuccess(results));
  } catch (err) {
    yield put(verifyInstalledAtInfoFailure(err));
  }
}

function* watchVerifyInstalledAtInfo() {
  yield takeLatest(actionTypes.VERIFY_INSTALLED_AT_INFO_REQUEST, verifyInstalledAtInfo);
}

function* watchFetchInstalledAtInfo() {
  yield takeLatest(actionTypes.INSTALLED_AT_INFO_REQUEST, doFetchInstalledAtInfo);
}

function* watchSaveInstalledAtInfo() {
  yield takeLatest(actionTypes.INSTALLED_AT_INFO_SAVE_REQUEST, doSaveInstalledAtInfo);
}

export default [
  fork(watchFetchInstalledAtInfo),
  fork(watchSaveInstalledAtInfo),
  fork(watchVerifyInstalledAtInfo),
];
